import React, {memo, useMemo} from 'react';
import {Box, Container, SimpleGrid, Skeleton} from '@mantine/core';
import {MembersListItem} from './MembersListItem';
import classes from './MembersList.module.scss';
import type {Member} from '@/types/member';
import {TitleDecor} from "@/components/TitleDecor/TitleDecor";


type Props = {
    members: Member[];
    loading?: boolean;
    error?: string | null;
};

export const MembersList: React.FC<Props> = memo(function MembersList({
                                                                          members = [],
                                                                          loading = false,
                                                                          error = null
                                                                      }: Props) {
    const content = useMemo(() => {
        if (loading) {
            return (
                <SimpleGrid cols={{base: 1, sm: 2}} spacing={{base: 'md', md: 'lg'}}>
                    {Array.from({length: 6}).map((_, i) => (
                        <Skeleton key={i} height={160} radius="md"/>
                    ))}
               </SimpleGrid>
            );
        }


        if (error) {
            return (
                <div className={classes.empty}>Loading error: {error}</div>
            );
        }


        if (!members.length) {
            return (
                <div className={classes.empty}>There are no members to display.</div>
            );
        }

        return (
            <SimpleGrid cols={{base: 1, sm: 2}} spacing={{base: 'md', md: 'lg'}} className={classes.grid}>
                {members.map((member) => (
                    <MembersListItem key={member.id ?? member.pathname} member={member}/>
                ))}
            </SimpleGrid>
        );
    }, [loading, error, members])

    return (
        <Box id="amaProsList" className={classes.meetThePros}>
            <Container>
                <TitleDecor mb="3rem">
                    Meet <span>the Pros</span>
                </TitleDecor>
                {content}
            </Container>
        </Box>
    )
});